export const apiBaseUrl = process.env.REACT_APP_BASE_URL || 'https://api.jupiter.com.br'